import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import getters from './getters'
import currentUser from './modules/current-user'
import currentSetting from './modules/current-setting'
import searchInfo from './modules/search-info'
import currentTenant from './modules/current-tenant'
import windowResize from './modules/window-resize'
import continueCreate from './modules/continue-create'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    currentUser,
    currentSetting,
    searchInfo,
    currentTenant,
    windowResize,
    continueCreate
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js